import Webcam from "react-webcam";
import { useCallback, useRef, useState } from "react";
import { useParams } from "react-router-dom"; // ← NUEVO
import axios from "axios";
import { FaPlay } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { FiCommand } from "react-icons/fi";

const WebCamContainer = () => {

    const { albumId } = useParams(); // ← lee /scanner/:albumId de la URL

    const [resultado, setResultado] = useState("");
    const [show, setShow] = useState(false);
    const [cortinaShow, setCortinaShow] = useState(false);
    const [playShow, setPlayShow] = useState(true);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const webcamRef = useRef(null);
    const [imgSrc, setImgSrc] = useState(null);

    const retake = () => {
        setCortinaShow(false);
        setPlayShow(true);
        setImgSrc(null);
        setShow(false);
    };

    const capture = useCallback(() => {
        setCortinaShow(true);
        setPlayShow(false);
        const imageSrc = webcamRef.current.getScreenshot();
        setImgSrc(imageSrc);

        const formData = new FormData();
        formData.append("file", imageSrc);
        formData.append("album_id", albumId); // ← NUEVO: enviar album_id

        const instance = axios.create({
            baseURL: "https://app.criodemicorazon.com",
            timeout: 20000,
        });

        instance.post('/post-photo', formData)
            .then(response => {
                const data = response.data;

                if (data.status === 404) {
                    console.log("No encontrado");
                    alert("Foto no encontrada, por favor intente de nuevo");
                    retake();
                } else {
                    setResultado(data.url_resource);
                    handleShow();
                }
            })
            .catch(error => console.log(error));

    }, [webcamRef, albumId]); // ← agregar albumId a dependencias

    const videoConstraints = {
        facingMode: { exact: "environment" }
    };

    const BtnPlay = () => (
        <FaPlay className="btn_play" onClick={capture} />
    );

    const Cortina = () => (
        <div className="cortina">
            <FiCommand className="loading-icon" />
            <br />
            <button className="btn_retake" onClick={retake}>Tomar foto nuevo</button>
        </div>
    );

    // Si no hay albumId en la URL mostrar error
    if (!albumId) {
        return (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
                <h2>URL inválida</h2>
                <p>Se requiere un álbum para usar el scanner.</p>
            </div>
        );
    }

    return (
        <>
            {cortinaShow ? <Cortina /> : null}
            <div className="container_wc">
                {imgSrc ? (
                    <img src={imgSrc} alt="webcam" />
                ) : (
                    <Webcam
                        height={1000}
                        width={1000}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        screenshotFormat="image/jpeg"
                        screenshotQuality={1}
                        forceScreenshotSourceSize="true"
                        videoConstraints={videoConstraints}
                        ref={webcamRef}
                    />
                )}
                {playShow ? <BtnPlay /> : null}
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Video</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        title="Resultado del Video"
                        className="embed-responsive-item video_sitio"
                        src={resultado + 'badge=0&autoplay=1&loop=1'}
                        allowscriptaccess="always"
                        allow="autoplay">
                    </iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={retake}>Cerrar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default WebCamContainer;